const DB = "bz_pending";
const STORE = "files";
const KEY = "letter";
const TTL = 24 * 3600 * 1000;

const open = () =>
  new Promise((resolve, reject) => {
    const req = indexedDB.open(DB, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });

const tx = async (mode, fn) => {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const req = fn(t.objectStore(STORE));
    t.oncomplete = () => resolve(req?.result);
    t.onerror = () => reject(t.error);
  });
};

export const ALLOWED = ["image/jpeg", "image/png", "image/webp", "application/pdf"];
export const MAX_SIZE = 10 * 1024 * 1024;

export const savePending = (file) => tx("readwrite", (s) => s.put({ blob: file, name: file.name, type: file.type, at: Date.now() }, KEY));

export const clearPending = () => tx("readwrite", (s) => s.delete(KEY)).catch(() => {});

export const getPending = async () => {
  try {
    const v = await tx("readonly", (s) => s.get(KEY));
    if (!v) return null;
    if (Date.now() - v.at > TTL) {
      await clearPending();
      return null;
    }
    return new File([v.blob], v.name, { type: v.type });
  } catch {
    return null;
  }
};
